import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { DropdownFilter } from '../../Planner/Filters/DropdownFilter';

import ReferralPriorities from '../../../containers/Admin/ReferralPriorities/ReferralPrioritiesContainer';
import ReferralSources from '../../../containers/Admin/ReferralSourcesContainer/ReferralSourcesContainer';
import ReferralServices from '../../../containers/Admin/ReferralServices/ReferralServicesContainer';

export default function ReferralConfigPage() {
  const [state, setState] = useState({
    options: [{ id: 0, name: 'Services' }, { id: 1, name: 'Sources' }, { id: 2, name: 'Priorities' }],
    selectedType: 0,
  });

  const renderContentByType = () => {
    switch (state.selectedType) {
      case 0:
        return <ReferralServices />;
      case 1:
        return <ReferralSources />;
      case 2:
        return <ReferralPriorities />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <section className="slick-page-header-section">
        <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
          <Box p={1}>
            <FilterListIcon />
          </Box>
          <Box p={1} width={130} textAlign="end">
            <span>Configure Referral</span>
          </Box>
          <Box p={1} width={300}>
            <DropdownFilter
              data={state.options}
              defaultValue={[state.options[0].id]}
              filterKey={'type'}
              filterValue={state.selectedType}
              onChange={(name, value) => setState({ ...state, selectedType: value })}
            />
          </Box>
        </Box>
      </section>
      {renderContentByType()}
    </React.Fragment>
  );
}
